import { PinataPayTransactionResult } from './pinata_pay_transaction_result.js';

export function name(result: PinataPayTransactionResult): string {
  switch (result) {
    case PinataPayTransactionResult.Approval:
      return 'Approval';
    case PinataPayTransactionResult.Decline:
      return 'Decline';
    case PinataPayTransactionResult.PartialApproval:
      return 'Partial Approval';
    case PinataPayTransactionResult.ProcessingError:
      return 'Processing Error';
    case PinataPayTransactionResult.Invalid:
      return 'Invalid';
    case PinataPayTransactionResult.Cancelled:
      return 'Cancelled';
    case PinataPayTransactionResult.RefundFailure:
      return 'Refund Failure';
    case PinataPayTransactionResult.Delayed:
      return 'Delayed';
    default:
      result satisfies never;
      throw new Error(`Unknown PinataPayTransactionResult: ${result}`);
  }
}
